module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6uoTL"))).then(() => parcelRequire('hEqeo'));